export const ActionTypes = {
  LOADING: "REGISTER_LOADING",
  ERROR: "REGISTER_ERROR",
  SUCCESS: "REGISTER_SUCCESS",
};
